import React from 'react'
import { useDispatch } from 'react-redux';
import { AutocompleteSearch } from '../../../components';
import { useFilterDefectType } from '../_redux/slice';
import { featchFilterDefectType } from '../_redux/thunk';

/**
 * 
 * @param {import('@material-ui/lab').AutocompleteProps<Structure> & {
 *  enabledSearch?: boolean
 * }} param0 
 * @returns 
 */
const DefectType = ({ enabledSearch = true, ...props }) => {
    // Redux
    const dispatch = useDispatch()
    const filter = useFilterDefectType();

    // Carrega dado especifico
    const onLoading = ({ enabledSearch, searchString }) => {
        dispatch(featchFilterDefectType({ enabledSearch, searchString }))
    }

    return (
        <AutocompleteSearch
            {...props}
            inputLabel="Pesquise pelo tipo de defeito"
            enabledSearch={false}
            options={filter.entities}
            onLoading={onLoading}
            />
    )
}

export default DefectType